var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilledUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.29102 7.29773C10.0293 6.67984 10.4996 5.74643 10.4996 4.702C10.4996 3.83302 10.174 3.04089 9.63942 2.4434C10.0835 2.1622 10.6065 2 11.1663 2C12.7771 2 14.0829 3.34312 14.0829 4.99994C14.0829 6.65676 12.7771 7.99988 11.1663 7.99988C10.4522 7.99988 9.79804 7.73594 9.29102 7.29773ZM12.0046 14C12.3213 13.5105 12.4996 12.9575 12.4996 12.3722C12.4996 11.008 11.5309 9.81959 10.0991 9.2001H12.9163C14.5271 9.2001 15.8329 10.5432 15.8329 12.2C15.8329 13.1941 15.0494 14 14.0829 14H12.0046Z",
    fill: "#6B92FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.16699 12.6667C1.16699 10.8258 2.65938 9.33337 4.50033 9.33337H8.50033C10.3413 9.33337 11.8337 10.8258 11.8337 12.6667C11.8337 13.7713 10.9382 14.6667 9.83366 14.6667H3.16699C2.06242 14.6667 1.16699 13.7713 1.16699 12.6667Z",
    fill: "#6B92FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.16699 4.66671C3.16699 2.82576 4.65938 1.33337 6.50033 1.33337C8.34127 1.33337 9.83366 2.82576 9.83366 4.66671C9.83366 6.50766 8.34127 8.00004 6.50033 8.00004C4.65938 8.00004 3.16699 6.50766 3.16699 4.66671Z",
    fill: "#6B92FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilledUsers);
export default __webpack_public_path__ + "static/media/filledUsers.be730deb.svg";
export { ForwardRef as ReactComponent };